import { render, staticRenderFns } from "./screeningResult.vue?vue&type=template&id=641f2d70&scoped=true&"
import script from "./screeningResult.vue?vue&type=script&lang=js&"
export * from "./screeningResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641f2d70",
  null
  
)

export default component.exports